import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";

export default function CitiesCovered() {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    api.get("/public/booking/cities").then(({ data }) => setCities(data.cities || [])).catch(() => {});
  }, []);

  if (!cities.length) return null;

  return (
    <section className="scroll-mt-20 bg-white px-6 py-16 sm:px-12 lg:px-20" data-testid="cities-section" id="villes">
      <div className="mx-auto max-w-5xl">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand">Villes couvertes</p>
          <h2 className="mt-2 text-3xl font-black tracking-tight text-ink sm:text-4xl">Où reste-t-il des places ?</h2>
          <p className="mx-auto mt-3 max-w-xl text-neutral-500">
            Touche ta ville pour voir les offres disponibles ce mois-ci.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-3" data-testid="cities-list">
          {cities.map((c) => (
            <Link
              key={c.city_norm}
              to={`/reserver?ville=${encodeURIComponent(c.city)}`}
              data-testid={`city-chip-${c.city_norm}`}
              className="group inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2.5 text-sm font-semibold text-ink shadow-sm transition-colors hover:border-brand hover:text-brand"
            >
              <MapPin className="h-4 w-4 text-brand" />
              {c.city}
              {c.remaining > 0 && (
                <span className="rounded-full bg-brand/10 px-2 py-0.5 text-xs font-bold text-brand">
                  {c.remaining} place{c.remaining > 1 ? "s" : ""}
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
